module.exports = __webpack_public_path__ + "assets/img/ground.1fb0b95e.png";